import {
    partnerOnboardingSignup,
    verifyPartnerOnboardingCode,
    verifyPartnerOnboardingCodeSuccess,
} from '@perpay-web/fintech/actions/entities/partnerOnboarding';

const initialState = () => ({
    inPartnerOnboardingFlow: false,
    isMagicLinkRedirect: true,
    partnerOnboardingCodeVerificationLoading: false,
    partnerCode: null,
    offerCode: null,
    offerAmount: null,
});

const partnerOnboardingReducer = (state = initialState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case partnerOnboardingSignup().type:
            // user went through regular partner onboarding signup
            // rather than magic link.
            return { ...state, isMagicLinkRedirect: false };

        case verifyPartnerOnboardingCode().type:
            return { ...state, partnerOnboardingCodeVerificationLoading: true };

        case verifyPartnerOnboardingCodeSuccess().type:
            return {
                ...state,
                partnerOnboardingCodeVerificationLoading: false,
                inPartnerOnboardingFlow: true,
                partnerCode: payload.partnerCode,
                offerCode: payload.offerCode,
                offerAmount: payload.offerAmount,
                premiumCardApplicant: payload.premiumCardApplicant,
            };

        default:
            return state;
    }
};

export default partnerOnboardingReducer;
